import { EventBus } from '@/event-bus'

export default class DragHandler {
  posX: number
  posY: number

  defaultMargin = 20
  stickMargin = 30

  stickMarginRight = -1
  stickMarginBottom = -1

  neverMoved = true

  restrictionWidth: number
  private headerHeight = 54

  constructor(
    // the component on which to click for dragging
    private dragTarget: HTMLElement,
    // the component that is moved on dragging
    private dragContent: HTMLElement, // uncomment if an offset is needed for the draghandler // offsetTop: number = dragContent.offsetTop, // offsetLeft: number = dragContent.offsetLeft
    private parentId: string,
  ) {}

  enableDragging(): void {
    this.dragTarget.style.cursor = 'move'
    this.dragTarget.addEventListener('mousedown', this.dragMouseDown.bind(this))

    this.updateStickMargins()

    window.addEventListener('resize', this.updatePositionOnResize.bind(this))
  }

  dragMouseDown(e: MouseEvent) {
    EventBus.emit('startDrag')
    e.preventDefault()

    this.neverMoved = false
    this.posX = e.clientX
    this.posY = e.clientY
    document.onmouseup = this.closeDragElement.bind(this)
    document.onmousemove = this.elementDrag.bind(this)
  }

  elementDrag(e: MouseEvent): void {
    e.preventDefault()

    // calculate the new position:
    const offsetX = this.posX - e.clientX
    const offsetY = this.posY - e.clientY
    this.posX = e.clientX
    this.posY = e.clientY
    // update position
    const el = this.dragContent

    const height = document.getElementById(this.parentId)?.offsetHeight || 1200
    let newTop = el.offsetTop - offsetY
    newTop = Math.max(newTop, 0)
    newTop = Math.min(newTop, height + this.headerHeight - el.offsetHeight)

    const width = document.getElementById(this.parentId)?.offsetWidth || 2000
    let newLeft = el.offsetLeft - offsetX
    newLeft = Math.max(newLeft, 0)
    newLeft = Math.min(newLeft, width - el.offsetWidth)

    el.style.top = newTop + 'px'
    el.style.left = newLeft + 'px'

    this.updateStickMargins()
  }

  updateStickMargins(): void {
    this.stickMarginRight = this.rightMargin() < this.stickMargin ? this.rightMargin() : -1
    this.stickMarginBottom = this.bottomMargin() < this.stickMargin ? this.bottomMargin() : -1
  }

  rightMargin(): number {
    const el = this.dragContent
    return window.innerWidth - el.offsetLeft - el.offsetWidth
  }

  bottomMargin(): number {
    const el = this.dragContent
    return window.innerHeight - el.offsetTop - el.offsetHeight
  }

  closeDragElement(): void {
    /* stop moving when mouse button is released: */
    document.onmouseup = null
    document.onmousemove = null
  }

  updatePositionOnResize(): void {
    if (!this.neverMoved) {
      const el = this.dragContent
      if (this.bottomMargin() <= this.defaultMargin) {
        el.style.top = Math.max(window.innerHeight - el.offsetHeight - this.defaultMargin, 0) + 'px'
      }
      if (this.rightMargin() <= this.defaultMargin) {
        el.style.left = Math.max(window.innerWidth - el.offsetWidth - this.defaultMargin, 0) + 'px'
      }
      if (this.stickMarginRight >= 0) {
        el.style.left = window.innerWidth - el.offsetWidth - this.stickMarginRight + 'px'
      }
      if (this.stickMarginBottom >= 0) {
        el.style.top = window.innerHeight - el.offsetHeight - this.stickMarginBottom + 'px'
      }
    }
  }

  setNewPosition(x: number, y: number): void {
    const el = this.dragContent

    el.style.top = y - this.headerHeight + 'px'
    el.style.left = x + 'px'

    this.updateStickMargins()
  }

  setRestriction(newRestrictionWidth: number): void {
    this.restrictionWidth = newRestrictionWidth
  }
}
